import React from "react";
// import Image from "next/image";
import Marker from "assets/map_pin.png";

export const PinMarker = ({ label }: { label?: string }) => {
  return (
    <div className="Pin">
      <img src={Marker} alt="Map pin marker" />
      {/* <Image src={Marker} alt="Map pin marker" /> */}
      {label && (
        <span className="whitespace-nowrap font-semibold">{label}</span>
      )}
    </div>
  );
};

export default PinMarker;
